import React from "react";
import styles from "./OurPartners.module.css";
import Images from "../../ALL_Images/Images.js";

const featuredPartners = [
  Images.Bark,
  Images.Canvera,
  Images.SulekhaLogo,
  Images.Sortlist,
  Images.Tripadvisor,
  Images.Trustpilot,
  Images.WedMeGood,
  Images.WeddingWire,
  Images.Bark,
  Images.Canvera,
  Images.SulekhaLogo,
  Images.Sortlist,
  Images.Tripadvisor,
  Images.Trustpilot,
  Images.WedMeGood,
  Images.WeddingWire,
];

const OurPartners = () => {
  return (
    <div className={styles["featured-partner__container"]}>
      <h1>Our Featured Partners</h1>
      <div className={styles["image-slider__container"]}>
        <div className={styles["image-box"]}>
          {featuredPartners.map((image, id) => (
            <div className={styles["image"]}>
              <img
                onContextMenu={(e) => {
                  e.preventDefault();
                }}
                loading="lazy"
                src={image}
                key={id}
                alt="featuredPartners"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OurPartners;
